import { FormControlLabel, Switch } from '@material-ui/core';
import React, { FunctionComponent } from 'react';

import styles from './ToggleButton.module.scss';

interface Props {
  onChange: (evt: any) => void;
  value: boolean;
  label?: string;
}

const ToggleButton: FunctionComponent<Props> = ({ onChange, value, label }) => {
  return (
    <span className={styles.ToggleButton}>
      <FormControlLabel
        checked={value}
        control={<Switch color="primary" />}
        onChange={onChange}
        label={label || ''}
      />
    </span>
  );
};

export default ToggleButton;
